function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M111.528 79.6122C108.259 79.2403 104.972 79.0497 101.682 79.0414H0V180.825C0 229.65 39.5382 269.235 88.3222 269.235H189.996L118.098 197.265C85.9651 165.093 83.7829 114.319 111.528 79.6046",
  fill: "#D4D590"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M278.318 79.0414C274.988 79.0414 271.703 79.2469 268.464 79.6046C296.217 114.311 294.035 165.093 261.895 197.265L189.996 269.235H291.678C340.454 269.235 380 229.658 380 180.825V79.0414H278.318Z",
  fill: "#C7D095"
});

var _ref4 =
/*#__PURE__*/
React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 111,
  y: 0,
  width: 158,
  height: 168
}, React.createElement("path", {
  d: "M111.528 0.266418H268.464V167.452H111.528V0.266418Z",
  fill: "white"
}));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M189.996 167.452C189.996 121.96 224.326 84.5062 268.464 79.6046C266.412 77.0294 264.219 74.5698 261.895 72.2371L189.996 0.266418L118.098 72.2371C115.74 74.5965 113.558 77.0625 111.528 79.6046",
  fill: "#E4DF96"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M111.528 79.6123C83.7829 114.319 85.9651 165.093 118.098 197.265L189.996 269.236V167.445C189.996 121.953 155.666 84.5062 111.528 79.5971",
  fill: "#B7BE8F"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M268.464 79.6122C224.326 84.5138 189.996 121.96 189.996 167.452V269.235L261.895 197.265C294.035 165.093 296.209 114.319 268.464 79.6046",
  fill: "#A7AD91"
});

var SvgIconBanner = function SvgIconBanner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 380,
    height: 270,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconBanner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-banner.6d7ff384.svg";
export { ForwardRef as ReactComponent };